export default __webpack_public_path__ + "static/media/manzil_image3-mobile.png.webp";